import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { KPI } from '../../data/mockData';
interface KPICardProps {
  kpi: KPI;
  compact?: boolean;
  isLoading?: boolean;
}
export function KPICard({
  kpi,
  compact = false,
  isLoading = false
}: KPICardProps) {
  if (isLoading) {
    return <Card className="h-full bg-slate-900 border-slate-800" data-id="element-2426">
        <CardContent className={compact ? 'p-3' : 'p-5'} data-id="element-2427">
          <div className="animate-pulse" data-id="element-2428">
            <div className="flex justify-between items-start mb-3" data-id="element-2429">
              <div className="h-4 bg-slate-800 rounded w-24" data-id="element-2430"></div>
              <div className="h-4 w-4 bg-slate-800 rounded" data-id="element-2431"></div>
            </div>
            <div className="flex items-baseline gap-2 mb-2" data-id="element-2432">
              <div className="h-8 bg-slate-800 rounded w-16" data-id="element-2433"></div>
              <div className="h-4 bg-slate-800 rounded w-10" data-id="element-2434"></div>
            </div>
            {!compact && <div className="h-3 bg-slate-800 rounded w-full mt-3" data-id="element-2435"></div>}
          </div>
        </CardContent>
      </Card>;
  }
  return <Card className="h-full bg-slate-900 border-slate-800" data-id="element-2436">
      <CardContent className={compact ? 'p-3' : 'p-5'} data-id="element-2437">
        <div className="flex justify-between items-start mb-2" data-id="element-2438">
          <p className={`text-slate-400 font-medium ${compact ? 'text-xs' : 'text-sm'}`} data-id="element-2439">
            {kpi.label}
          </p>
          {kpi.trend === 'up' && <ArrowUpRight className="w-4 h-4 text-emerald-500" data-id="element-2440" />}
          {kpi.trend === 'down' && <ArrowDownRight className="w-4 h-4 text-red-500" data-id="element-2441" />}
          {kpi.trend === 'neutral' && <Minus className="w-4 h-4 text-slate-600" data-id="element-2442" />}
        </div>

        <div className="flex items-baseline gap-2" data-id="element-2443">
          <h3 className={`font-bold text-slate-100 ${compact ? 'text-xl' : 'text-2xl'}`} data-id="element-2444">
            {kpi.value}
          </h3>
          <span className={`text-xs font-medium ${kpi.trend === 'up' ? 'text-emerald-400' : kpi.trend === 'down' ? 'text-red-400' : 'text-slate-500'}`} data-id="element-2445">
            {kpi.trendValue}
          </span>
        </div>

        {!compact && <p className="text-xs text-slate-500 mt-2" data-id="element-2446">{kpi.description}</p>}
      </CardContent>
    </Card>;
}